export const GET_INVOICE = "GET_INVOICE";
export const GET_ALL_INVOICES = "GET_ALL_INVOICES";
export const LOADING = "LOADING";
export const GET_ERRORS = "GET_ERRORS";
